import { Injectable } from '@angular/core';
import { LocalStorageService } from 'src/app/project/services/local-storage.service';
import { ELocalStorageItems } from 'src/app/project/shared/enums/local-storage-items.enum';
import { TLocalStorageSidePanelData } from './account-list-constants';
import {
  ADD_COLLAPSED_ACCOUNT,
  ADD_COLLAPSED_FOLDER,
  GET_COLLAPSED_ACCOUNTS,
  GET_COLLAPSED_FOLDERS,
  GET_FAVOURITES_COLLAPSED,
  getExpandedFoldersChange$,
  SET_FAVOURITES_COLLAPSED,
} from './account-list.ui.store';

@Injectable({
  providedIn: 'root',
})
export class AccountListUiLocalStorageService {
  constructor(private localStorageService: LocalStorageService) {
    getExpandedFoldersChange$().subscribe(() => {
      this.savePreferencesToLocalStorage();
    });
  }

  loadPreferencesFromLocalStorage(): void {
    const localStorageData = this.localStorageService.getItem<TLocalStorageSidePanelData>(
      ELocalStorageItems.COLLAPSED_SIDE_PANEL_ITEMS,
    );

    if (!localStorageData) {
      return;
    }
    const restoredAccounts = localStorageData.collapsedAccounts || [];

    SET_FAVOURITES_COLLAPSED(localStorageData.favouritesCollapsed, false);

    restoredAccounts.forEach((accountId: string) => {
      ADD_COLLAPSED_ACCOUNT(accountId, false);
    });

    Object.keys(localStorageData.collapsedFolders).forEach((accountId: string) => {
      localStorageData.collapsedFolders[accountId].forEach((folderId: string) => {
        ADD_COLLAPSED_FOLDER(accountId, folderId, false);
      });
    });
  }

  private savePreferencesToLocalStorage(): void {
    const localStorageData: TLocalStorageSidePanelData = {
      favouritesCollapsed: GET_FAVOURITES_COLLAPSED(),
      collapsedAccounts: Array.from(GET_COLLAPSED_ACCOUNTS()),
      collapsedFolders: GET_COLLAPSED_FOLDERS(),
    };

    this.localStorageService.saveItem(
      ELocalStorageItems.COLLAPSED_SIDE_PANEL_ITEMS,
      JSON.stringify(localStorageData),
    );
  }

  clearSidePanelPreferencesStore(): void {
    this.localStorageService.removeItem(ELocalStorageItems.COLLAPSED_SIDE_PANEL_ITEMS);
  }
}
